import { $, $$ } from '@zimpa/dom';
import axios, { AxiosResponse } from 'axios';

const CONTAINER_SELECTOR = '.js-form';
const SUCCESS_SELECTOR = '.js-form-success';
const ERROR_SELECTOR = '.js-form-error';
const FORM_SELECTOR = '.js-form-form';
const FORM_ITEM_SELECTOR = '.js-form-form-item';

const SHOW_CLASS = 'show';
const HIDE_CLASS = 'hide';

export function instance(
    form: HTMLElement,
    success: HTMLElement,
    error: HTMLElement,
): void {
    form.addEventListener('submit', (event: Event): void => {
        event.preventDefault();

        const data = {};

        $$(FORM_ITEM_SELECTOR, form).forEach((el: HTMLInputElement): void => {
            if (data[el.name]) {
                if (!Array.isArray(data[el.name])) {
                    data[el.name] = [data[el.name]];
                }

                data[el.name].push(el.value);
            } else {
                data[el.name] = el.value;
            }
        });

        axios
            .post(<string>form.getAttribute('action'), data)
            .then((response: AxiosResponse<any>): void => {
                form.classList.add(HIDE_CLASS);

                if (response.data === null) {
                    error.classList.add(SHOW_CLASS);
                } else {
                    success.classList.add(SHOW_CLASS);
                }
            });
    });
}

export function form(): void {
    $$(CONTAINER_SELECTOR).forEach((container: HTMLElement): void => {
        const form = $<HTMLElement>(FORM_SELECTOR, container);
        const success = $<HTMLElement>(SUCCESS_SELECTOR, container);
        const error = $<HTMLElement>(ERROR_SELECTOR, container);

        if (
            form === undefined ||
            success === undefined ||
            error === undefined
        ) {
            return;
        }

        instance(form, success, error);
    });
}
